// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "d0deef33" + "." + "b7061ff3dace0c44" + ".js";
};